// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__17RJ_","log":"ModalInventoryLogs_log__1f85r","date":"ModalInventoryLogs_date__18j9-","userName":"ModalInventoryLogs_userName__3pLKb"};